<template>
  <div>
    <v-btn
      color="primary"
      dark
      class="mr-5"
      v-if="customerId"
      :disabled="isAllTextFieldDisable"
      @click="selectRepairPriceBomsBtn"
    >
      選擇修改Bom
    </v-btn>
    <v-dialog v-model="isShowEditCustomerRepairBomDialog" fullscreen persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('common_edit') }}</span>
        </v-card-title>
        <v-data-table
          :headers="customerRepairBomDataTableHeaders"
          :items="computedCustomerRepairBoms"
          class="elevation-1 ma-5 "
          :search="searchCustomerRepairBom"
          :loading-text="$t('common_get_data')"
          :no-data-text="$t('common_no_data')"
          :no-results-text="$t('common_no_results')"
          :footer-props="{
            'items-per-page-options': [30, 50, 100],
            'items-per-page-text': $t('item_rows_per_page'),
          }"
          :header-props="headerProps"
          v-model="selectCustomerRepairBoms"
          item-key="Index"
          show-select
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ $t('customer_repair_item_toolbar_title') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchCustomerRepairBom"
                append-icon="mdi-magnify"
                :label="$t('customer_repair_item_search_label')"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-toolbar>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="closeSelectCustomerRepairBoms"
            :disabled="isAllTextFieldDisable"
          >
            {{ $t('common_cancel') }}
          </v-btn>
          <v-btn
            color="green darken-1"
            :disabled="selectCustomerRepairBoms.length === 0"
            text
            @click="addSelectCustomerRepairBoms"
          >
            {{ $t('common_confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { HttpUpdateCustomerRepair } from '@/js/http-Manager'
export default {
  name: 'SelectRepairItemBom',
  data: () => ({
    searchCustomerRepairBom: '',
    isShowEditCustomerRepairBomDialog: false,
    customerRepairBoms: [],
    selectCustomerRepairBoms: []
  }),
  props: {
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: String
    }
  },
  mounted () {},
  watch: {},
  computed: {
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    customerRepairBomDataTableHeaders () {
      return [
        { text: 'BOM名稱', align: 'start', value: 'Name' },
        { text: 'BOM描述', align: 'start', value: 'Describe' },
        { text: 'BOM價格', align: 'start', value: 'Price' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    },
    computedCustomerRepairBoms () {
      let array = []
      if (this.customerRepairBoms) {
        this.customerRepairBoms.forEach((item, index) => {
          array.push({
            ...item,
            Index: index + 1
          })
        })
      }
      return array
    }
  },
  methods: {
    async selectRepairPriceBomsBtn () {
      await this.getCustomerRepairBoms()
      this.isShowEditCustomerRepairBomDialog = true
    },
    closeSelectCustomerRepairBoms () {
      this.selectCustomerRepairBoms = []
      this.customerRepairBoms = []
      this.isShowEditCustomerRepairBomDialog = false
    },
    addSelectCustomerRepairBoms () {
      this.$emit('addSelectCustomerRepairBoms', this.selectCustomerRepairBoms)
      this.closeSelectCustomerRepairBoms()
    },
    async getCustomerRepairBoms () {
      let param = {
        customerId: this.customerId
      }
      let response = await HttpUpdateCustomerRepair.GetCustomerRepairBoms(param)
      if (response && response.status === 200) {
        this.customerRepairBoms = response.data.Data
      }
    }
  }
}
</script>
